//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from './SfButton/SfButton.vue';
import SfIcon from './SfIcon.vue';
import SfImage from './SfImage.vue';
import SfLink from './SfLink.vue';
import SfPrice from './SfPrice.vue';
import SfProperty from './SfProperty.vue';
import SfQuantitySelector from './SfQuantitySelector.vue';

export default {
  name: 'SfCollectedProduct',
  components: {
    SfButton,
    SfIcon,
    SfImage,
    SfPrice,
    SfQuantitySelector,
    SfLink,
    SfProperty,
  },
  model: {
    prop: 'qty',
  },
  props: {
    image: {
      type: String,
      default: '',
    },
    imageWidth: {
      type: [Number, String],
      default: 140,
    },
    imageHeight: {
      type: [Number, String],
      default: 200,
    },
    title: {
      type: String,
      default: '',
    },
    regularPrice: {
      type: [Number, String],
      default: null,
    },
    specialPrice: {
      type: [Number, String],
      default: null,
    },
    qty: {
      type: [Number, String],
      default: 1,
    },
    minQty: {
      type: Number,
      default: null,
    },
    maxQty: {
      type: Number,
      default: null,
    },
    link: {
      type: [String, Object],
      default: null,
    },
    hasRemove: {
      type: Boolean,
      default: true,
    },
    hasMoreActions: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    componentIs() {
      return this.link ? 'SfLink' : 'div';
    },
    quantity() {
      return typeof this.qty === 'string' ? Number(this.qty) : this.qty;
    },
  },
  methods: {
    removeHandler() {
      this.$emit('click:remove');
    },
    actionsHandler() {
      this.$emit('click:actions');
    },
  },
};
